<template>
  <v-data-table
    :loading="loading"
    :headers="headersToShow"
    :items="entities"
    :rows-per-page-items="[10, 20, 30, 50, 100]"
    :pagination.sync="paginationModel"
    :total-items="paginationModel.totalItems"
    class="small-data-table"
  >
    <template slot="items" slot-scope="props">
      <template v-for="col of headersToShow">
        <td :class="getTdClass(col)" :key="`${props.item.id}-${col.value}`">
          <template v-if="col.value == 'actions'">
            <v-btn
              v-if="props.item.status === 'processed'"
              small
              flat
              icon
              color="grey"
              class="pa-0 ma-0"
              @click="download(props.item)"
            >
              <v-icon small>mdi-download</v-icon>
            </v-btn>

            <v-btn class="pa-0 ma-0" small flat icon color="error" @click="deleteItem(props.item)">
              <v-icon small>delete</v-icon>
            </v-btn>
          </template>
          <template v-else-if="col.value == 'request'">
            <span v-if="props.item.request.from">
              <v-chip>Desde: {{ props.item.request.from | moment('DD/MM/YYYY') }}</v-chip>
            </span>
            <span v-if="props.item.request.to">
              <v-chip>hasta: {{ props.item.request.to | moment('DD/MM/YYYY') }}</v-chip>
            </span>
            <span v-if="props.item.request.include_inactives">
              <v-chip>Con U. inactivos</v-chip>
            </span>
            <span v-if="props.item.request.rolename">
              <v-chip>Rol: {{ props.item.request.rolename }}</v-chip>
            </span>
            <span v-if="props.item.request.clavedat">
              <v-chip>Cod. Empresa.: {{ props.item.request.clavedat }}</v-chip>
            </span>
          </template>
          <template v-else-if="col.value == 'status'">
            <span v-if="props.item.status === 'requested'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="grey">mdi-progress-upload</v-icon>
                </template>
                <span>{{ $t('Abierta') }}</span>
              </v-tooltip>
            </span>
            <span v-if="props.item.status === 'processing'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon color="secondary" v-on="on">mdi-clock-outline</v-icon>
                </template>
                <span>{{ $t('En proceso') }}</span>
              </v-tooltip>
            </span>
            <span v-if="props.item.status === 'processed'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="primary">mdi-check</v-icon>
                </template>
                <span>{{ $t('Finalizada') }}</span>
              </v-tooltip>
            </span>
            <span v-if="props.item.status === 'file_error'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="error">mdi-alert-circle-outline</v-icon>
                </template>
                <span>{{ $t('Con errores') }}</span>
              </v-tooltip>
            </span>
          </template>

          <template v-else-if="'type'">
            {{ $t(props.item[col.value]) }}
          </template>
          <template v-else>
            {{ props.item[col.value] }}
          </template>
        </td>
      </template>
    </template>
    <template slot="no-data">
      <v-btn color="primary" @click="initialize">{{ $t('Reset') }}</v-btn>
    </template>
  </v-data-table>
</template>

<script>
export default {
  components: {},
  props: {
    entities: {
      type: Array,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    adminView: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
      default() {
        return {
          descending: true,
          page: 1,
          rowsPerPage: 10, // -1 for All",                    <v-icon color="primary">mdi-check</v-icon>
        };
      },
    },
  },
  data() {
    return {
      dialog: false,
      headers: [
        {
          text: 'ID',
          align: 'left',
          value: 'id',
          sortable: false,
        },
        { text: 'Tipo', value: 'type' },
        { text: 'Nombre', value: 'name' },
        { text: 'Detalles', value: 'request' },

        { text: 'Estado', value: 'status' },

        { text: 'Acciones', value: 'actions', align: 'right', sortable: false },
      ],
    };
  },

  computed: {
    headersToShow() {
      return this.headers.filter(item => {
        return true;
      });
    },

    paginationModel: {
      get: function() {
        return this.pagination;
      },
      set: function(value) {
        this.$emit('update:pagination', value);
      },
    },
  },

  watch: {},

  created() {
    this.initialize();
  },

  methods: {
    getTdClass(col) {
      if (col.value === 'actions') {
        return `text-xs-right pr-0`;
      }

      return `text-xs-left`;
    },
    download(item) {
      this.$emit('download-item-clicked', item);
    },

    deleteItem(item) {
      this.$emit('delete-item-clicked', item);
    },

    initialize() {},
  },
};
</script>

<style></style>
